document.addEventListener('DOMContentLoaded', function() {

  // ===== PRELOADER =====
  var preloader = document.getElementById('preloader');
  if (preloader) {
    var bar = document.getElementById('preloader-bar');
    var progress = 0;
    var interval = setInterval(function() {
      progress += Math.random() * 20 + 5;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        setTimeout(function() {
          preloader.classList.add('preloader--hidden');
        }, 300);
      }
      if (bar) bar.style.width = progress + '%';
    }, 200);
  }

  // ===== MOBILE MENU =====
  var menuToggle = document.getElementById('menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileClose = document.getElementById('mobile-close');
  var mobileOverlay = document.getElementById('mobile-overlay');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('mobile-menu--open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('mobile-menu--open');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ===== HERO SLIDER =====
  var slides = document.querySelectorAll('.hero-slider__slide');
  var dots = document.querySelectorAll('.hero-slider__dot');
  var currentSlide = 0;
  var slideInterval;

  function goToSlide(index) {
    slides.forEach(function(slide) { slide.classList.remove('hero-slider__slide--active'); });
    dots.forEach(function(dot) { dot.classList.remove('hero-slider__dot--active'); });
    if (slides[index]) slides[index].classList.add('hero-slider__slide--active');
    if (dots[index]) dots[index].classList.add('hero-slider__dot--active');
    currentSlide = index;
  }

  function nextSlide() {
    goToSlide((currentSlide + 1) % slides.length);
  }

  if (slides.length > 1) {
    slideInterval = setInterval(nextSlide, 5000);
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        clearInterval(slideInterval);
        goToSlide(parseInt(this.getAttribute('data-dot')));
        slideInterval = setInterval(nextSlide, 5000);
      });
    });
  }

  // ===== EMAIL POPUP =====
  var emailPopup = document.getElementById('email-popup');
  var emailClose = document.getElementById('email-popup-close');
  var emailOverlay = document.getElementById('email-popup-overlay');

  if (emailPopup) {
    var dismissed = sessionStorage.getItem('email_popup_dismissed');
    if (!dismissed) {
      setTimeout(function() {
        emailPopup.style.display = 'block';
        emailPopup.style.opacity = '0';
        setTimeout(function() {
          emailPopup.style.transition = 'opacity 0.3s ease';
          emailPopup.style.opacity = '1';
        }, 10);
      }, 4000);
    }
  }

  function closeEmailPopup() {
    if (emailPopup) {
      emailPopup.style.opacity = '0';
      setTimeout(function() {
        emailPopup.style.display = 'none';
      }, 300);
      sessionStorage.setItem('email_popup_dismissed', 'true');
    }
  }

  if (emailClose) emailClose.addEventListener('click', closeEmailPopup);
  if (emailOverlay) emailOverlay.addEventListener('click', closeEmailPopup);

  // ===== PRODUCT PAGE: IMAGE GALLERY =====
  var mainImage = document.getElementById('main-product-image');
  var thumbs = document.querySelectorAll('.product-page__thumb');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var imageUrl = this.getAttribute('data-image-url');
      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;
        thumbs.forEach(function(t) { t.classList.remove('product-page__thumb--active'); });
        this.classList.add('product-page__thumb--active');
      }
    });
  });

  // ===== PRODUCT PAGE: QUANTITY =====
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  var qtyInput = document.getElementById('qty-input');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // ===== CART: QUANTITY BUTTONS =====
  document.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = this.getAttribute('data-key');
      var action = this.getAttribute('data-action');
      var input = document.querySelector('input[data-key="' + key + '"]');
      if (!input) return;

      var val = parseInt(input.value) || 0;
      if (action === 'minus' && val > 0) val--;
      if (action === 'plus') val++;
      input.value = val;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: val })
      }).then(function() {
        window.location.reload();
      });
    });
  });

  // ===== QUICK ADD TO CART =====
  document.querySelectorAll('.product-card__quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = this.getAttribute('data-product-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        var cartCount = document.getElementById('cart-count');
        if (cartCount) {
          cartCount.textContent = parseInt(cartCount.textContent || '0') + 1;
        }
        btn.style.background = 'var(--color-gold)';
        btn.style.color = '#fff';
        setTimeout(function() {
          btn.style.background = '';
          btn.style.color = '';
        }, 1000);
      });
    });
  });

  // ===== PORTFOLIO PROJECT GALLERIES =====
  var galleryStates = {};

  document.querySelectorAll('.project-gallery-next').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var blockId = this.getAttribute('data-block-id');
      navigateGallery(blockId, 1);
    });
  });

  document.querySelectorAll('.project-gallery-prev').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var blockId = this.getAttribute('data-block-id');
      navigateGallery(blockId, -1);
    });
  });

  document.querySelectorAll('.portfolio-project__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var blockId = this.getAttribute('data-block-id');
      var index = parseInt(this.getAttribute('data-index'));
      var src = this.getAttribute('data-src');
      setGalleryImage(blockId, index, src);
    });
  });

  function navigateGallery(blockId, direction) {
    var thumbsContainer = document.querySelector('.portfolio-project__thumbs[data-block-id="' + blockId + '"]');
    if (!thumbsContainer) return;
    var allThumbs = thumbsContainer.querySelectorAll('.portfolio-project__thumb');
    var totalImages = allThumbs.length;
    if (!galleryStates[blockId]) galleryStates[blockId] = 0;

    var newIndex = (galleryStates[blockId] + direction + totalImages) % totalImages;
    var newSrc = allThumbs[newIndex].getAttribute('data-src');
    setGalleryImage(blockId, newIndex, newSrc);
  }

  function setGalleryImage(blockId, index, src) {
    galleryStates[blockId] = index;

    var mainImg = document.querySelector('.project-gallery-main[data-block-id="' + blockId + '"]');
    if (mainImg && src) mainImg.src = src;

    var thumbsContainer = document.querySelector('.portfolio-project__thumbs[data-block-id="' + blockId + '"]');
    if (thumbsContainer) {
      thumbsContainer.querySelectorAll('.portfolio-project__thumb').forEach(function(t, i) {
        t.classList.toggle('portfolio-project__thumb--active', i === index);
      });
    }

    var counter = document.querySelector('.project-gallery-counter[data-block-id="' + blockId + '"]');
    if (counter) {
      var total = thumbsContainer ? thumbsContainer.querySelectorAll('.portfolio-project__thumb').length : 0;
      counter.textContent = (index + 1) + ' / ' + total;
    }
  }

  // ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

});
